import { render, staticRenderFns } from "./labelSetting.vue?vue&type=template&id=e7c7db72&scoped=true&"
import script from "./labelSetting.vue?vue&type=script&lang=js&"
export * from "./labelSetting.vue?vue&type=script&lang=js&"
import style0 from "./labelSetting.vue?vue&type=style&index=0&id=e7c7db72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c7db72",
  null
  
)

export default component.exports